import {DatasetDropdown} from "components/basic/dropdowns/dataset/DatasetDropdown";
import {ICommonComponentEditorProps} from "components/ComponentType";
import {ILastKnownValueTimeMomentProps} from "components/dashboard/last-known-value-time-moment/LastKnownValueTimeMoment";
import {Dropdown} from "primereact/dropdown";
import {InputNumber} from "primereact/inputnumber";
import {InputText} from "primereact/inputtext";
import React, {useEffect, useState} from "react";

const defaultLastValueTimeIndicatorEditorConfig: ILastKnownValueTimeMomentProps = {
    identifier: "",
    customText: "",
    dateFormat: "yyyy-MM-dd HH:mm:ss",
    updateFrequency: 0
}

const DATETIME_FORMAT_OPTIONS = [
    {label: "yyyy-MM-dd HH:mm:ss", value: "yyyy-MM-dd HH:mm:ss"},
    {label: "yyyy-MM-dd HH:mm", value: "yyyy-MM-dd HH:mm" },
    {label: "yyyy-MM-dd HH", value: "yyyy-MM-dd HH" },
    {label: "yyyy-MM-dd", value: "yyyy-MM-dd"}
]

const LastKnownValueTimeMomentEditor = ({ config, onConfigChange }: ICommonComponentEditorProps) =>{
        let conf: any = config ?? defaultLastValueTimeIndicatorEditorConfig

    if (Object.keys(conf).length === 0) {
        conf = defaultLastValueTimeIndicatorEditorConfig;
    }

    const [currentConfig, setCurrentConfig] = useState(conf);

    useEffect(() => {
        onConfigChange(currentConfig);
    }, [currentConfig]);

    const setConfigPropertyState = (property: keyof ILastKnownValueTimeMomentProps, value: any) => {
        setCurrentConfig((prevState: ILastKnownValueTimeMomentProps) => ({...prevState, [property]: value}));
    };

    const handleConfigChange = (e: any): void => {

        setConfigPropertyState(e.target.id as keyof ILastKnownValueTimeMomentProps, e.target.value);
    };
    return (
        <div className="grid p-fluid">
            <div className="flex gap-2 w-full pl-2 pr-2">
                <DatasetDropdown onChange={handleConfigChange} value={currentConfig.identifier}/>
            </div>
            <div className="col-12 gap-2 flex flex-column justify-content-center align-items-start">
                <label htmlFor="customText">Custom Text</label>
                <InputText id="customText" value={currentConfig.customText} onChange={(e) => handleConfigChange(e)}/>
            </div>
            <div className="col-2 gap-2 flex flex-column justify-content-center align-items-center">
                <label htmlFor="updateFrequency">Update Frequency</label>
                <div className="p-inputgroup w-full">
                    <InputNumber
                        id="updateFrequency"
                        value={currentConfig.updateFrequency as number}
                        onValueChange={(e) => handleConfigChange(e)}
                    />
                    <span className="p-inputgroup-addon">s</span>
                </div>
            </div>
            <div className="col-4 gap-2 flex flex-column justify-content-center align-items-center">
                <label htmlFor="dateFormat">Date Format</label>
                <Dropdown id="dateFormat" value={currentConfig.dateFormat} options={DATETIME_FORMAT_OPTIONS} onChange={(e) => handleConfigChange(e)}/>
            </div>

        </div>


    )
}

export default LastKnownValueTimeMomentEditor;